import { IRevenueCodeWithCodeDto } from 'common/interfaces/invoices';
import { ImmutableObject } from 'common/state/interfaces';

export enum FeeType {
  OneTime = 'ONE_TIME',
  Regular = 'REGULAR',
}

export interface IFee {
  id?: string;
  title: string;
  active: boolean;
  type: FeeType;
  revenueCode: IRevenueCodeWithCodeDto | null;
}
export type IFeeImt = ImmutableObject<IFee>;
